import { getActiveCompanyId } from '../lib/activeCompany';
import type { User } from '../types';

/** Resolves the admin tenant id used to scope data for this user. */
export function getAdminId(user: User | null): string | null {
  if (!user) return null;

  if (user.role === 'admin') {
    // Admins may hold access to several companies in the agency; the active one
    // comes from the token claim and falls back to their own company.
    return getActiveCompanyId() || user.id;
  }

  if (user.role === 'super_admin') {
    return user.id;
  }

  if (user.role === 'worker' || user.role === 'viewer') {
    return user.admin_id || null;
  }

  return null;
}
